module.exports = __webpack_public_path__ + "mainassets/img/tile-2-2h.48b310a6.jpg";